module.exports = __webpack_public_path__ + "fonts/e44ff74881f2996d1658a165fd0ae692.svg";